import React, { useMemo } from 'react';
import { Box, Divider, Flex, TextV2 } from '@withjoy/joykit';
import { Calendar } from '@withjoy/joykit/icons';
import { pxToRem } from '@withjoy/joykit/theme';
import { useTranslation } from '@shared/core';
import { useResponsive } from '@shared/utils/hooks/useResponsive';
import { createDateFromUnformattedString } from '@shared/utils/dateHelpers';
import { useFormattedDate } from '@shared/hooks/useFormattedDate';
import { useFormattedDateRange } from '@shared/hooks/useFormattedDateRange';

export const RoomBlockDate = ({ checkInDate, checkOutDate, cutoffDate }: { checkInDate?: string | null; checkOutDate?: string | null; cutoffDate?: string | null }) => {
  const { t } = useTranslation('websiteEditor');
  const hotelTrans = t('customPage', 'travelMap', 'hotel');
  const [isMobile] = useResponsive({ values: { mobile: true, tablet: false } });

  const parsedCutoffDate = useMemo(() => (cutoffDate ? (createDateFromUnformattedString(cutoffDate) ?? new Date(cutoffDate)) : null), [cutoffDate]);
  const parsedCheckInDate = useMemo(() => (checkInDate ? (createDateFromUnformattedString(checkInDate) ?? new Date(checkInDate)) : null), [checkInDate]);
  const parsedCheckOutDate = useMemo(() => (checkOutDate ? (createDateFromUnformattedString(checkOutDate) ?? new Date(checkOutDate)) : null), [checkOutDate]);

  const formattedCutoffDate = useFormattedDate(parsedCutoffDate, 'MMMdd');
  const formattedCheckInOutDateRange = useFormattedDateRange(parsedCheckInDate, parsedCheckOutDate);

  const fallbackCutoffDate = useFormattedDate(new Date(new Date().getFullYear() + 1, 0, 2), 'MMMdd'); // Jan 2, next year

  if (!checkInDate || !checkOutDate) return null;

  return (
    <Flex
      gap={{ _: 3, sm: 5 }}
      borderRadius="full"
      border="1px solid"
      borderColor="mono3"
      paddingX={5}
      paddingY={3}
    >
      <Flex
        gap={1}
        alignItems="center"
        width={{ _: pxToRem(107), sm: pxToRem(144) }}
      >
        <Box color="mono10">
          <Calendar size={16} />
        </Box>
        <TextV2
          typographyVariant="label2"
          color="mono14"
        >
          {isMobile ? hotelTrans.by() : hotelTrans.bookBy()} {formattedCutoffDate ?? fallbackCutoffDate}
        </TextV2>
      </Flex>
      <Divider orientation="vertical" />
      <Flex
        gap={1}
        alignItems="center"
        width={{ _: pxToRem(107), sm: pxToRem(144) }}
      >
        <Box color="mono10">
          <Calendar size={16} />
        </Box>
        <TextV2
          typographyVariant="label2"
          color="mono14"
        >
          {formattedCheckInOutDateRange}
        </TextV2>
      </Flex>
    </Flex>
  );
};
